// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-element[data-v-1a0db14f]{height:100%}.templates-block[data-v-1a0db14f]{position:relative}\n", ""]);
// Exports
module.exports = exports;
